import React, { useEffect, useState } from "react";
import { apiGet } from "api/callApi";
import PageNotFound from "components/PageNotFound";
import Shimmer, { ShimmerWrapper } from "./Shimmer";

const AdminProtectedRoute = ({ element }) => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(false);

  const checkAdminStatus = async () => {
    try {
      setLoading(true);
      const response = await apiGet(`/v1/admindashboard`, false);
      if (response?.success == "success") {
        setIsAdmin(true);
        setLoading(false);
      } else {
        setIsAdmin(false);
        setLoading(false);
      }
    } catch (error) {
      console.error("Admin check failed:", error);
      setIsAdmin(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAdminStatus();
  }, [element]);

  if (loading)
    return (
      <>
        <ShimmerWrapper />
        <div style={{ padding: "5px" }}>
          <Shimmer height="50px" width="100%" />
          <div
            style={{
              marginTop: "5px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
            }}
          >
            <Shimmer height="65px" width="100%" />
            <Shimmer height="500px" width="100%" />
          </div>
        </div>
      </>
    );

  return isAdmin ? (
    element
  ) : (
    <PageNotFound heading={"Admin access denied"} message={""} />
  );
};

export default AdminProtectedRoute;
